module.exports = __webpack_public_path__ + "img/addFamily.dcaef927.png";